import { handleActions } from 'redux-actions';
import { DATA_SOURCES_GET } from '../../constants/constants';

const initialState = {};

export default handleActions({
  [DATA_SOURCES_GET.SUCCESS]: (state, { payload }) => payload
}, initialState);
